module.exports = __webpack_public_path__ + "static/media/05_MINS-2.0-Q-14 1.58ef7024.svg";